import { render, staticRenderFns } from "./NonSACitizen.vue?vue&type=template&id=7ee3ed1d"
import script from "./NonSACitizen.vue?vue&type=script&lang=js"
export * from "./NonSACitizen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports